import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { Route as TransactionsRoute } from "@app/navigation/routes/_private/transactions";
import { OrderDetailsPageConnector } from "@pages/order-details";

export const Route = createFileRoute("/_private/orders/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  const onGoBack = () => {
    navigate({ to: TransactionsRoute.fullPath });
  };
  return <OrderDetailsPageConnector id={id} onGoBack={onGoBack} />;
}
